import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
	PartnerMutationKeys,
	PartnerQueryKeys,
} from '../../../../manage-player/keys'
import { GetPartnerByIdResponse } from '../../../../manage-player/type'
import {
	addCreditToPartner,
	AddCreditToPartnerRequest,
} from '../../../../manage-player/api/services'

interface UseMutationAddCreditToPartnerProps {
	partnerId: string
	payload: AddCreditToPartnerRequest
}

export default function useMutationAddCreditToPartner(
	props?: UseBaseMutationOptions<
		GetPartnerByIdResponse,
		UseMutationAddCreditToPartnerProps
	>,
) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationKey: [PartnerMutationKeys.AddCreditToPartner],
		mutationFn: (params) =>
			addCreditToPartner(params.partnerId, params.payload),
		onSuccess: () => {
			// Invalidate partner queries to refresh data
			queryClient.invalidateQueries({
				queryKey: [PartnerQueryKeys.GetPartners],
			})
		},
		...props,
	})
}
